<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.7058 7.4117C12.7058 10.3355 10.3355 12.7058 7.4117 12.7058C4.48786 12.7058 2.11763 10.3355 2.11763 7.4117C2.11763 4.48786 4.48786 2.11763 7.4117 2.11763C10.3355 2.11763 12.7058 4.48786 12.7058 7.4117ZM11.8528 13.346C10.6151 14.2738 9.07758 14.8234 7.4117 14.8234C3.31833 14.8234 0 11.5051 0 7.4117C0 3.31833 3.31833 0 7.4117 0C11.5051 0 14.8234 3.31833 14.8234 7.4117C14.8234 9.07543 14.2752 10.6111 13.3496 11.848L17.6928 16.1912C18.1063 16.6047 18.1063 17.2751 17.6928 17.6886C17.2793 18.1021 16.6089 18.1021 16.1954 17.6886L11.8528 13.346Z"
    fill="#D4D8E2"
  />
</template>
